import React from "react";
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";
import { useTranslation } from "react-i18next";
const EvalCompInfo = ({ companyDetailModal, setCompanyDetailModal, evalDetailData }) => {
	const { t } = useTranslation();
	return (
		<ModalTemplate
			modalState={companyDetailModal}
			setModalToggle={setCompanyDetailModal}
			title={evalDetailData?.company?.name}
			width={640}
			className="company-detail-modal"
		>
			<div className="modal-content">
				<div className="c__form">
					<div className="f__group">
						<div className="f__label">
							{t("pages.round.RoundList.component.EvalCompInfo.ceoName")}
						</div>
						<div className="f__control">{evalDetailData?.company?.ceoName}</div>
					</div>
					<div className="f__group">
						<div className="f__label">
							{t("pages.round.RoundList.component.EvalCompInfo.sales")}
						</div>
						<div className="f__control">
							{evalDetailData?.company?.sales}{" "}
							{evalDetailData?.company?.salesYear !== null
								? "(" +
								  evalDetailData?.company?.salesYear +
								  `${t("pages.round.RoundList.component.EvalCompInfo.year")})`
								: ""}
						</div>
					</div>
					<div className="f__group">
						<div className="f__label">
							{t("pages.round.RoundList.component.EvalCompInfo.bizType")}
						</div>
						<div className="f__control">{evalDetailData?.company?.bizType}</div>
					</div>
					<div className="f__group">
						<div className="f__label">
							{t("pages.round.RoundList.component.EvalCompInfo.estDate")}
						</div>
						<div className="f__control">
							{evalDetailData?.company?.estDate.substring(0, 10)}
						</div>
					</div>
					<div className="f__group">
						<div className="f__label">
							{t("pages.round.RoundList.component.EvalCompInfo.employeeNum")}
						</div>
						<div className="f__control">{evalDetailData?.company?.employeeNum}</div>
					</div>
					<div className="f__group">
						<div className="f__label">
							{t("pages.round.RoundList.component.EvalCompInfo.certType")}
						</div>
						<div className="f__control">{evalDetailData?.company?.certType}</div>
					</div>
					<div className="f__group">
						<div className="f__label">
							{t("pages.round.RoundList.component.EvalCompInfo.country")}
						</div>
						<div className="f__control">
							{evalDetailData?.company?.country === "KR"
								? t("pages.round.RoundList.component.EvalCompInfo.korea")
								: t("pages.round.RoundList.component.EvalCompInfo.other")}
						</div>
					</div>
					<div className="f__group">
						<div className="f__label">
							{t("pages.round.RoundList.component.EvalCompInfo.isListed")}
						</div>
						<div className="f__control">
							{evalDetailData?.company?.listed
								? t("pages.round.RoundList.component.EvalCompInfo.listed")
								: t("pages.round.RoundList.component.EvalCompInfo.notListed")}
						</div>
					</div>
					<div className="f__group">
						<div className="f__label">
							{t("pages.round.RoundList.component.EvalCompInfo.address")}
						</div>
						<div className="f__control">
							({evalDetailData?.company?.zipCode}) {evalDetailData?.company?.address}
						</div>
					</div>
					<div className="f__group">
						<div className="f__label">
							{t("pages.round.RoundList.component.EvalCompInfo.homePage")}
						</div>
						<div className="f__control">{evalDetailData?.company?.homepage}</div>
					</div>
				</div>
				<div className="c__form vertical">
					<div className="f__group major-product">
						<div className="f__label">
							{t("pages.round.RoundList.component.EvalCompInfo.mainProduct")}{" "}
							<span>{evalDetailData?.product?.name}</span>
						</div>
						<div className="f__control">{evalDetailData?.product?.description}</div>
					</div>
				</div>
			</div>
			<div className="modal-footer">
				<button
					type="button"
					className="btn__solid"
					color="primary"
					onClick={() => setCompanyDetailModal(false)}
				>
					{t("pages.round.RoundList.component.EvalCompInfo.close")}
				</button>
			</div>
		</ModalTemplate>
	);
};

export default EvalCompInfo;
